import type { DiagnosisGroupDto } from './diagnoses/diagnosis-group.dto';

export class GeneralConfigurationDto {
  diagnosisGroup: DiagnosisGroupDto;
}
